import React from "react";
import { TableRow, TableCell, Checkbox, Box } from "@mui/material";
import { capitalizeFirstLetter, truncateText } from "../../../../constants";

export const TableRowSection = ({
  row,
  isItemSelected,
  labelId,
  handleClick,
  handleRowClick,
  showDefault = true,
  showStatus = true,
}) => {
  // Format timestamp to readable date
  const formatDate = (timestamp) => {
    if (!timestamp) return "-";
    if (timestamp.seconds) {
      return new Date(timestamp.seconds * 1000).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
    return "-";
  };

  // Get status chip style
  const getStatusStyle = (status) => {
    const baseStyle = {
      padding: "4px 12px",
      borderRadius: "4px",
      fontSize: "12px",
      fontFamily: "Avenir Book, sans-serif",
      display: "inline-block",
    };

    if (status === "active") {
      return {
        ...baseStyle,
        backgroundColor: "#E8F5E9",
        color: "#2E7D32",
      };
    } else {
      return {
        ...baseStyle,
        backgroundColor: "#FFEBEE",
        color: "#C62828",
      };
    }
  };

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      }}
    >
      {/* Checkbox */}
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
          onClick={(event) => {
            event.stopPropagation();
            handleClick(event, row.id);
          }}
        />
      </TableCell>

      {/* Name - clickable */}
      <TableCell
        component="th"
        id={labelId}
        scope="row"
        sx={{
          fontFamily: "Avenir Book, sans-serif",
          color: "#0AB2EE",
          fontWeight: 500,
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
        onClick={() => handleRowClick(row.id)}
      >
        {row.name || "-"}
      </TableCell>

      {/* Description */}
      <TableCell
        sx={{
          fontFamily: "Avenir Book, sans-serif",
          color: "#595959",
        }}
      >
        {row.description ? truncateText(row.description, 50) : "-"}
      </TableCell>

      {/* Logo thumbnail */}
      <TableCell>
        {row.logo ? (
          <Box
            component="img"
            src={row.logo}
            alt="Logo"
            sx={{
              width: 20,
              height: 20,
              objectFit: "cover",
              borderRadius: "2px",
            }}
          />
        ) : (
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: "#e0e0e0",
              borderRadius: "2px",
            }}
          />
        )}
      </TableCell>

      {/* Updated At */}
      <TableCell
        sx={{
          fontFamily: "Avenir Book, sans-serif",
          color: "#595959",
        }}
      >
        {formatDate(row.updatedAt)}
      </TableCell>

      {/* Updated By */}
      <TableCell
        sx={{
          fontFamily: "Avenir Book, sans-serif",
          color: "#595959",
        }}
      >
        {row.updatedByData?.userName || row.updatedByData?.firstName || "-"}
      </TableCell>

      {/* Status */}
      {showStatus && (
        <TableCell>
          <Box sx={getStatusStyle(row.status)}>
            {capitalizeFirstLetter(row.status) || "Active"}
          </Box>
        </TableCell>
      )}

      {/* Default (read-only checkbox) - hidden for standard templates */}
      {showDefault && (
        <TableCell align="center">
          <Checkbox
            color="primary"
            checked={!!row.default}
            disabled
            inputProps={{ "aria-label": row.default ? "Default template" : "Not default template" }}
          />
        </TableCell>
      )}
    </TableRow>
  );
};

export default TableRowSection;
